export const statusColor: Record<string, string> = {
  open: '#1890ff',
  inProgress: '#fa8c16',
  done: '#52c41a',
};
export const priorityColor: Record<string, string> = {
  critical: '#f5222d',
  high: '#fa8c16',
  medium: '#faad14',
  low: '#8c8c8c',
};
